import type {IssueEventItem} from '../../../../page-data/payloads/timeline'

function shortOid(oid: string): string {
  return oid.slice(0, 7)
}

export function ForcePushedText({item}: {item: IssueEventItem}) {
  const {ref, beforeCommitOid, afterCommitOid} = item.additionalInfo
  if (!beforeCommitOid || !afterCommitOid) return <>force pushed</>
  return (
    <>
      <span>force-pushed </span>
      {ref ? <strong>{ref}</strong> : <span>this branch</span>}
      <span> from </span>
      <strong>{shortOid(beforeCommitOid)}</strong>
      <span> to </span>
      <strong>{shortOid(afterCommitOid)}</strong>
    </>
  )
}
